import React from 'react';
import { Button, Box } from '@material-ui/core';
import { TextField } from '@mui/material';
import { Controller, useForm } from 'react-hook-form';

import Modal, { ModalContents, ModalTitle, ModalTypography } from 'components/Modal/Modal';

export const RejectExternalDonationModal = ({
  multiple,
  onClose,
  onReject,
}: {
  multiple: boolean;
  onClose: () => void;
  onReject: (data: { rejectionReason: string }) => void;
}) => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm<{ rejectionReason: string }>({
    defaultValues: {
      rejectionReason: '',
    },
    mode: 'onChange',
  });

  return (
    <Modal style={{ zIndex: 1200 }} open fullWidth onClose={onClose}>
      <ModalContents
        onClickClose={onClose}
        body={
          <Box mb={4}>
            <ModalTitle>Reject Donation Match Request{multiple ? 's' : ''}</ModalTitle>
            <ModalTypography>
              Are you sure you want to reject {multiple ? 'all these' : 'this'} donation match
              request
              {multiple ? 's' : ''}? This will notify the requester{multiple ? 's' : ''} with the
              rejection reason.
            </ModalTypography>
            <Controller
              name="rejectionReason"
              control={control}
              rules={{
                required: `Please enter a reason for the donation match request${
                  multiple ? 's' : ''
                } rejection`,
                maxLength: 300,
              }}
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Rejection Reason"
                  helperText={`Why ${multiple ? 'are these' : 'is this'} donation match request${
                    multiple ? 's' : ''
                  } being rejected?`}
                  fullWidth
                  required
                  variant="standard"
                  error={Boolean(errors.rejectionReason)}
                />
              )}
            />
          </Box>
        }
        actions={
          <Button
            color="primary"
            type="button"
            variant="contained"
            style={{ marginRight: 8 }}
            onClick={handleSubmit(onReject)}
            disabled={!isValid}
          >
            Reject the donation match request{multiple ? 's' : ''}
          </Button>
        }
      />
    </Modal>
  );
};
